import { Directive, ElementRef, OnDestroy, OnInit, inject } from '@angular/core';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { Subject, takeUntil } from 'rxjs';


@Directive({
	standalone: true,
	selector: 'editor'
})
export class TinyMceDialogAppendDirective implements OnInit, OnDestroy
{
	private readonly el = inject(ElementRef);

	private readonly editorComp = inject(EditorComponent, { optional: true, self: true });

	private readonly destroy$ = new Subject<void>();

	ngOnInit(): void
	{
		const host = this.el.nativeElement as HTMLElement;
		const dialogContainer = host.closest('mat-dialog-container') as HTMLElement | null;

		if (!dialogContainer || !this.editorComp) {
			return;
		}

		this.editorComp.onInit
			.pipe(takeUntil(this.destroy$))
			.subscribe(({ editor }) => {
				const auxEl = this.findAuxElement(editor);
				if (auxEl) {
					dialogContainer.appendChild(auxEl);
				}
			});
	}

	ngOnDestroy(): void
	{
		this.destroy$.next();
		this.destroy$.complete();
	}

	private findAuxElement(editor: any): HTMLElement | null
	{
		const editorContainer = editor.editorContainer as HTMLElement | null;

		if (editorContainer) {
			const next = editorContainer.nextElementSibling as HTMLElement | null;
			if (next?.classList.contains('tox-tinymce-aux')) {
				return next;
			}
		}
		const allAux = Array.from(
			document.querySelectorAll<HTMLElement>('body > .tox-tinymce-aux')
		);
		return allAux[allAux.length - 1] ?? null;
	}
}
